import { Component } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-ai-solutionsforceecommerce-blog',
  templateUrl: './ai-solutionsforceecommerce-blog.component.html',
  styleUrls: ['./ai-solutionsforceecommerce-blog.component.css']
})
export class AiSolutionsforceecommerceBlogComponent {
  isBrowser: boolean = false;

  baseUrl = Constants.baseUrl;
  constructor(
    private titleService: Title, @Inject(PLATFORM_ID) private platformId: any,
    private seoService: SeoService,
    private metaService: Meta
  ) { this.isBrowser = isPlatformBrowser(this.platformId); }


  ngOnInit() {
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile' });

    }
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }


  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('AI Solutions for Ecommerce: Enhancing Customer Experiences and Business Success');

    this.metaService.addTags([
      { name: 'description', content: 'In the rapidly evolving landscape of e-commerce, the integration of Artificial Intelligence (AI) is proving to be a game-changer!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'AI Solutions for Ecommerce: Enhancing Customer Experiences and Business Success' },
      { property: 'og:description', content: 'In the rapidly evolving landscape of e-commerce, the integration of Artificial Intelligence (AI) is proving to be a game-changer!' },
    ]);
  }
}
